import { INVOICE_TYPE_ID } from '../constants/ObjectTypeIds';
const EDITABLE_PROPERTIES = new Set(['hubspot_owner_id']);
export const isReadOnlyInvoiceProperty = ({
  objectTypeId,
  property,
  isBillableInvoice
}) => {
  if (objectTypeId !== INVOICE_TYPE_ID || !property.hubspotDefined) {
    // if objectTypeId is not an invoice or it's a custom property, it should be editable
    return false;
  }

  // Controlling property (hs_invoice_billable) - Whether or not the invoice is billable
  // https://tools.hubteam.com/lighthouse/objects/INVOICE/properties/hs_invoice_billable/details/0
  if (isBillableInvoice === 'false' || EDITABLE_PROPERTIES.has(property.name)) {
    // If invoice is non-billable or the property is editable, it should not be read only
    return false;
  }

  // By default, invoice properties are read only
  return true;
};